import { BasePessoaModel } from "../base/base-pessoa-model";

export class PessoaModel extends BasePessoaModel { 
    public tipoEntidade: string;
}
